import { render, staticRenderFns } from "./TableMetadataHeaderMenu.vue?vue&type=template&id=49d47fdd&scoped=true&"
import script from "./TableMetadataHeaderMenu.vue?vue&type=script&lang=js&"
export * from "./TableMetadataHeaderMenu.vue?vue&type=script&lang=js&"
import style0 from "./TableMetadataHeaderMenu.vue?vue&type=style&index=0&id=49d47fdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d47fdd",
  null
  
)

export default component.exports